export enum AuthScheme {
  Bearer = 'Bearer',
  EthereumSig = 'EthereumSig',
}
